<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M13.1199 16C13.8099 16 14.2699 15.31 14.0199 14.68L9.76992 3.87C9.55992 3.34 9.05992 3 8.49992 3C7.93992 3 7.43992 3.34 7.22992 3.87L2.97992 14.68C2.72992 15.31 3.19992 16 3.87992 16C4.27992 16 4.63992 15.75 4.78992 15.37L5.66992 13H11.3099L12.2099 15.38C12.3599 15.75 12.7199 16 13.1199 16ZM6.42992 11L8.49992 5.48L10.5699 11H6.42992ZM20.8899 12.29L13.4999 19.68L10.5299 16.71C10.1399 16.32 9.50992 16.32 9.11992 16.71C8.72992 17.1 8.72992 17.73 9.11992 18.12L12.7999 21.8C13.1899 22.19 13.8199 22.19 14.2099 21.8L22.2899 13.71C22.6799 13.32 22.6799 12.69 22.2899 12.3C21.9099 11.91 21.2699 11.91 20.8899 12.29Z"
    fill="currentColor"
  />
</svg>
